/* eslint max-params: ["error", 5] */

import './rgaQuestionAnswer.scss';
import React, {Component} from 'react';
import LabeledTextArea from '../../../../../../claim/shared/components/claim-fields/labeled-text-area';
import PropTypes from 'prop-types';
import RgaDetails from '../../../../../rga-search-results/state/rga-details';
import RgaQuestionAnswer from '../../../../../rga-search-results/state/rga-question-answer';
import WarrantyLoadingIndicator from '../../../../../../shared/components/warranty-loading-indicator';
class RgaQuestionAns extends Component {

    componentWillMount() {

        this.props.actions.getRgaQandA(this.props.rgaDetails);

    }

    componentWillUnmount() {

        this.props.actions.resetProperties('qanda');

    }

    render() {

        const {rgaQuestionAnswer} = this.props;

        return (
            <section className='rga-recalled-form'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {rgaQuestionAnswer.map((qa, index) => (
                    <div
                        className='row'
                        key={index}
                    >
                        <LabeledTextArea
                            className='disabled-field-q-a'
                            disabled={true}
                            isEditable={true}
                            label={qa.question}
                            onChange={null}
                            value={qa.answer}
                        />
                    </div>
                ))}
            </section>
        );

    }
}

RgaQuestionAns.displayName = 'RgaQuestionAns';
RgaQuestionAns.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    rgaQuestionAnswer: PropTypes.arrayOf(PropTypes.instanceOf(RgaQuestionAnswer)).isRequired
};

export default RgaQuestionAns;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/returned-part-information/recalled-part-tab/components/rgaQuestionAnswer.js